/**
 * Drive Algolia InstantSearch from the D1 search hero.
 * Algolia's own box stays in the DOM (hidden) so InstantSearch keeps working.
 */
(function () {
  const HERO_ID = 'Search-In-Template';

  function markInstantSearch() {
    if (
      document.querySelector(
        '.ais-page, .ais-hits-container, .ais-hit, .ais-facets, .ais-stats-container, .ais-h2'
      )
    ) {
      document.body.classList.add('d1-has-algolia-instantsearch');
      return true;
    }
    return false;
  }

  function hoistThemeCss() {
    if (document.getElementById('d1-algolia-cascade')) return;
    const src = document.querySelector('link[href*="d1-algolia.css"]');
    if (!src) return;
    const link = src.cloneNode(true);
    link.id = 'd1-algolia-cascade';
    document.body.appendChild(link);
  }

  hoistThemeCss();

  if (document.body.classList.contains('template-search') && !markInstantSearch()) {
    const aisWatch = new MutationObserver(() => {
      if (markInstantSearch()) aisWatch.disconnect();
    });
    aisWatch.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => aisWatch.disconnect(), 8000);
  }

  function drawerRoot() {
    return document.querySelector('.header__search--drawer');
  }

  function drawerQueryInput(drawer) {
    return drawer.querySelector('.aa-Input') || drawer.querySelector('#Search-In-Modal');
  }

  function syncDrawerQueryState(drawer) {
    const input = drawerQueryInput(drawer);
    drawer.classList.toggle('is-searching', !!(input && String(input.value).trim()));
  }

  function parkNativeDrawerInput() {
    const drawer = drawerRoot();
    if (!drawer) return true;
    const aa = drawer.querySelector('.aa-Input');
    const native = drawer.querySelector('#Search-In-Modal');
    if (!aa) return false;
    if (native && native !== aa) {
      const hadFocus = document.activeElement === native;
      native.disabled = true;
      native.tabIndex = -1;
      native.setAttribute('aria-hidden', 'true');
      if (hadFocus) aa.focus({ preventScroll: true });
    }
    syncDrawerQueryState(drawer);
    return true;
  }

  if (!parkNativeDrawerInput()) {
    const drawer = drawerRoot();
    const parkWatch = new MutationObserver(() => {
      if (parkNativeDrawerInput()) parkWatch.disconnect();
    });
    parkWatch.observe(drawer || document.body, { childList: true, subtree: true });
    setTimeout(() => parkWatch.disconnect(), 8000);
  }

  const drawer = drawerRoot();
  if (drawer) {
    drawer.addEventListener('input', () => syncDrawerQueryState(drawer));
    drawer.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) syncDrawerQueryState(drawer);
      });
    });
  }

  function aisSearchInput() {
    return document.querySelector(
      '.ais-search-box-container input, .ais-SearchBox-input, input.ais-search-box--input'
    );
  }

  function setNativeValue(el, value) {
    const proto = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    if (proto && proto.set) proto.set.call(el, value);
    else el.value = value;
  }

  function syncHeroToAlgolia(value) {
    const input = aisSearchInput();
    if (!input || input.value === value) return;
    setNativeValue(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('input', (event) => {
    if (event.target && event.target.id === HERO_ID) {
      syncHeroToAlgolia(event.target.value);
    }
  });

  const hero = document.getElementById(HERO_ID);
  if (!hero) return;

  const push = () => syncHeroToAlgolia(hero.value);
  if (aisSearchInput()) {
    push();
    return;
  }

  const observer = new MutationObserver(() => {
    if (!aisSearchInput()) return;
    push();
    observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 8000);
})();
